'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoClock = function IoClock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c0.8-0.8 1.5-1.6 2.1-2.6l-2.2-1.2 0.7-1.1 2.1 1.3c1-2 1.6-4.1 1.7-6.4h-2.5v-1.2h2.5c-0.1-2.3-0.7-4.4-1.7-6.4l-2.1 1.3-0.7-1.1 2.2-1.2c-0.6-1-1.3-1.8-2.1-2.6s-1.6-1.5-2.6-2.1l-1.2 2.2-1.1-0.7 1.3-2.1c-2-1-4.1-1.6-6.4-1.7v2.5h-1.2v-2.5c-2.3 0.1-4.4 0.7-6.4 1.7l1.3 2.1-1.1 0.7-1.2-2.2c-1 0.6-1.8 1.3-2.6 2.1s-1.5 1.6-2.1 2.6l2.2 1.2-0.7 1.1-2.1-1.3c-1 2-1.6 4.1-1.7 6.4h2.5v1.2h-2.5c0.1 2.3 0.7 4.4 1.7 6.4l2.1-1.3 0.7 1.1-2.2 1.2c0.6 1 1.3 1.8 2.1 2.6s1.6 1.5 2.6 2.1l1.2-2.2 1.1 0.7-1.3 2.1c2 1 4.1 1.6 6.4 1.7v-2.5h1.2v2.5c2.3-0.1 4.4-0.7 6.4-1.7l-1.3-2.1 1.1-0.7 1.2 2.2c1-0.6 1.8-1.3 2.6-2.1z m0.7-11.8v2.5h-9.2c-0.5 0.7-1.2 1.2-2.1 1.2-1.4 0-2.5-1.1-2.5-2.5 0-0.9 0.5-1.7 1.3-2.2v-5.3h2.5v5.3c0.3 0.2 0.7 0.6 0.9 1h9.1z' })
        )
    );
};

exports.default = IoClock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/clock.js
// module id = 2473
// module chunks = 168707334958949